import { useEffect, useState } from 'react';

/**
 * Light/dark theme hook for the affiliate portal.
 *
 * Persists to localStorage under 'oak_theme'. Initial value is read in index.html
 * before React mounts (to prevent flash of unstyled theme).
 *
 * Applies the `dark` class on the <html> element (Tailwind's class strategy).
 */
export function useTheme() {
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    if (typeof document === 'undefined') return 'light';
    return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    try {
      localStorage.setItem('oak_theme', theme);
    } catch { /* ignore — private mode etc. */ }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  return { theme, setTheme, toggle };
}
